const PERMISSION_KEY= "core:user_login_activity";
const PAGE_URL = {
    USER_LOGIN_ACTIVITY_PAGE: "/admin/core/user-login-activity"
}

export {PERMISSION_KEY, PAGE_URL}

